import { useState } from "react";
import { eur, showMoney } from "@/lib/format";
import { useBestCustomers } from "@/components/BestCustomers";
import { ExpandToggle } from "@/components/ExpandToggle";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle, ChevronDown, Mail, Phone } from "lucide-react";

export const LapsedCustomers = ({ season, onSelect }) => {
  const { data } = useBestCustomers(season);
  const [open, setOpen] = useState(false);
  const [shown, setShown] = useState(false);
  if (!data) return null;
  return (
    <Card className="mb-6 p-5" data-testid="customers-lapsed">
      <button onClick={() => setShown(!shown)} className="flex w-full items-center justify-between gap-2 font-mono-erp text-[11px] uppercase tracking-widest text-muted-foreground hover:text-foreground" data-testid="lapsed-section-toggle">
        <span className="flex items-center gap-1.5 text-left"><AlertTriangle className="h-3.5 w-3.5 text-amber-500" />Clienti in calo · migliori di {data.prev_season} senza acquisti {data.season} · {data.lapsed.length}</span>
        <ChevronDown className={`h-4 w-4 shrink-0 transition-transform ${shown ? "rotate-180" : ""}`} />
      </button>
      {shown && <div className="mt-2" data-testid="lapsed-section-body">
      <p className="mb-3 text-xs text-muted-foreground">Le prime 20 per speso in {data.prev_season} che non hanno ancora comprato capi {data.season}: da ricontattare</p>
      {!data.lapsed.length ? <p className="text-sm text-muted-foreground" data-testid="customers-lapsed-empty">Nessuna cliente in calo</p> : (
        <div className={`grid grid-cols-1 gap-x-6 gap-y-1 ${open ? "md:grid-cols-2" : ""}`}>
          {(open ? data.lapsed : data.lapsed.slice(0, 3)).map((c) => (
            <div key={c.id} className="flex items-center justify-between gap-2 border-b border-border/40 py-1.5 text-sm" data-testid="customers-lapsed-row">
              <div className="min-w-0">
                <Button variant="link" className="h-auto p-0 text-sm text-foreground" onClick={() => onSelect(c.id)} data-testid={`customers-lapsed-open-${c.id}`}>{c.name}</Button>
                <div className="flex flex-wrap gap-x-3 text-[11px] text-muted-foreground">
                  {c.phone && <a href={`tel:${c.phone}`} className="flex items-center gap-1 hover:text-primary" data-testid={`customers-lapsed-phone-${c.id}`}><Phone className="h-3 w-3" />{c.phone}</a>}
                  {c.email && <a href={`mailto:${c.email}`} className="flex items-center gap-1 truncate hover:text-primary" data-testid={`customers-lapsed-email-${c.id}`}><Mail className="h-3 w-3" />{c.email}</a>}
                </div>
              </div>
              {showMoney() && <span className="shrink-0 text-xs font-semibold" data-testid={`customers-lapsed-prev-${c.id}`}>{eur(c.prev_spent)}</span>}
            </div>
          ))}
        </div>
      )}
      <ExpandToggle total={data.lapsed.length} open={open} onToggle={() => setOpen(!open)} limit={3} testid="customers-lapsed-toggle" />
      </div>}
    </Card>
  );
};
